/*
  Две полоски движения под плашками окупаемости — приём из варианта В.

  🔴 В макете варианта В полоска стояла ВНУТРИ плашки денег, и там же выяснилось,
  почему так нельзя: у плашек окупаемости нет помесячной истории. «Возвращено за
  период», «предотвращено списание», «сгорело до подключения» - это величины за
  отрезок целиком, а не ряд по месяцам; полоска внутри такой плашки показывала
  бы ряд, которого у неё нет. Ровно на этом вариант В и спотыкался - так и
  записано в разборе макетов.

  Поэтому полоски стоят ОТДЕЛЬНОЙ парой под плашками и показывают то, что
  действительно посчитано помесячно: долг портфеля и собираемость. Смысл
  варианта В при этом сохранён - направление движения видно, не уходя с вкладки
  плашек.

  У полоски намеренно нет осей и сетки: она показывает форму ряда, а величину
  говорит число рядом. Подробные графики с осями - на вкладке «Графики».

  🔴 Концы отрезка при этом подписаны месяцами (30.09.2026, замечание
  владельца: полоски «не информативны, нужны хотя бы временные отрезки снизу»).
  Без них линия отвечает на вопрос «куда движется», но не на вопрос «за какое
  время», - а один и тот же изгиб за три месяца и за четыре года означает
  совершенно разное.
*/

import { money, percent } from '../api/format.js'
import { Spark } from './ChartLine.jsx'
import InfoHint from './InfoHint.jsx'

export default function PortfolioSparks({ detail }) {
  /*
    Одна точка движения не показывает, и рисовать её незачем: при узком периоде
    (один месяц) пара полосок просто не появляется. Пустая рамка с подписью
    сообщила бы «движения нет» там, где верно «мерить нечем».
  */
  if (detail.months.length < 2) return null

  const debts = detail.months.map((month) => month.debt)
  const shares = detail.months.map((month) =>
    Number(month.charged) ? (Number(month.paid) / Number(month.charged)) * 100 : 0
  )
  const collected = Number(detail.totals.charged)
    ? Number(detail.totals.paid) / Number(detail.totals.charged)
    : null

  /*
    Концы отрезка - месяцами, а не датами: полоска строится по месяцам
    начисления, и «01.01.2026» на её конце обещало бы точность до дня, которой
    у неё нет.
  */
  const monthLabel = (iso) => {
    const [year, month] = iso.split('-')
    return `${month}.${year.slice(2)}`
  }
  const first = monthLabel(detail.months[0].title)
  const last = monthLabel(detail.months[detail.months.length - 1].title)

  return (
    <div className="grid grid--even">
      <div className="tile tile--spark">
        <div className="tile__head">
          <div className="money__label">Куда движется долг</div>
          <InfoHint
            title="Откуда цифра"
            text="Неоплаченный остаток начислений по месяцам выбранного периода. Число рядом - долг за период целиком."
          />
        </div>
        <div className="money__value">{money(detail.totals.debt)}</div>
        <Spark
          values={debts}
          from={first}
          to={last}
          alt="Долг по месяцам выбранного периода"
        />
      </div>

      <div className="tile tile--spark">
        <div className="tile__head">
          <div className="money__label">Куда движется собираемость</div>
          <InfoHint
            title="Откуда цифра"
            text="Доля оплаченного от начисленного по месяцам. «Оплачено» - отметка вашей учётной системы на день последнего обмена, а не деньги, дошедшие до счёта."
          />
        </div>
        <div className="money__value">{percent(collected)}</div>
        <Spark
          values={shares}
          from={first}
          to={last}
          alt="Доля оплаченного по месяцам выбранного периода"
        />
      </div>
    </div>
  )
}
